module.exports = __webpack_public_path__ + "media/images/review1-9421c6cc662ff78d10261bbcae6e70eb.jpg";